var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_23228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.389 8.793C18.3206 9.29732 20.3342 12.0222 19.9553 14.9727C19.5765 17.9231 16.9397 20.0509 13.9759 19.798C11.0119 19.5453 8.77375 17.0015 8.90012 14.0296C9.02648 11.0575 11.4724 8.71307 14.4472 8.71259C14.7629 8.71242 15.0779 8.73928 15.389 8.793Z",
    fill: "#63532A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3885 1.03025V8.79413C14.7437 8.6833 14.0844 8.68718 13.4409 8.80578L13.4396 8.79996V7.1124H11.0091V9.48291H11.6375C10.5447 10.132 9.70902 11.1381 9.27151 12.3314H9.27103C9.12703 12.062 8.84615 11.8937 8.54051 11.894H6.84762C6.39005 11.894 6.01921 12.2649 6.01921 12.7224V16.3939H5.29012e-08V1.03025C-0.000161745 0.572684 0.370841 0.201843 0.828406 0.201843H14.56C15.0176 0.201843 15.3885 0.572846 15.3885 1.03025ZM13.4396 4.68187V2.31153H11.0091V4.68187H13.4396ZM9.10049 9.48291V7.1124H6.26773V9.48291H9.10049ZM4.37939 14.2645V11.894H1.94886V14.2645H4.37939ZM4.37939 9.48291V7.1124H1.94886V9.48291H4.37939ZM4.37939 4.68187V2.31153H1.94886V4.68187H4.37939Z",
    fill: "#63532A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4393 8.80084L13.4406 8.80666C12.8041 8.9238 12.1935 9.15307 11.6372 9.48378H11.0088V7.11328H13.4393V8.80084Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0088 2.31183H13.4393V4.68217H11.0088V2.31183Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38364 16.3951H6.01953V12.7235C6.01953 12.266 6.39037 11.8951 6.84794 11.8951H8.54083C8.84647 11.8948 9.12735 12.0631 9.27135 12.3325H9.27183C8.79194 13.6518 8.83191 15.1042 9.38364 16.3951Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26758 7.11328H9.10034V9.48378H6.26758V7.11328Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94873 11.8936H4.37926V14.2641H1.94873V11.8936Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94873 7.11328H4.37926V9.48378H1.94873V7.11328Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94873 2.31183H4.37926V4.68217H1.94873V2.31183Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73065 3.7931L8.27576 3.33821L8.74197 2.872C8.90375 2.71022 8.90375 2.448 8.74197 2.28623C8.5802 2.12445 8.31798 2.12445 8.1562 2.28623L7.68999 2.75244L7.22812 2.29057C7.06635 2.1288 6.80412 2.1288 6.64235 2.29057C6.48058 2.45235 6.48058 2.71457 6.64235 2.87634L7.10422 3.33821L6.65368 3.78875C6.49202 3.95041 6.4919 4.21275 6.65368 4.37452C6.81545 4.5363 7.07779 4.53618 7.23945 4.37452L7.68999 3.92398L8.14488 4.37887C8.30665 4.54065 8.56887 4.54065 8.73065 4.37887C8.89242 4.2171 8.89242 3.95487 8.73065 3.7931Z",
    fill: "#FBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4785 11.5847C17.0077 12.1361 17.3015 12.8719 17.2973 13.6363C17.2999 14.4205 16.9951 15.1745 16.4482 15.7367L14.4162 18.1572L12.4142 15.767C11.3121 14.6291 11.3224 12.7627 12.4445 11.6149C12.9784 11.0572 13.7166 10.7409 14.4887 10.739C15.2394 10.7381 15.9579 11.0436 16.4785 11.5847ZM15.8596 13.4908C15.8596 12.7103 15.2269 12.0777 14.4464 12.0777C13.6659 12.0777 13.0331 12.7103 13.0331 13.4908C13.0331 14.2715 13.6659 14.9041 14.4464 14.9041C15.2268 14.904 15.8594 14.2713 15.8596 13.4908Z",
    fill: "#FBF1D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_23228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyAddress);
export default __webpack_public_path__ + "static/media/company-address.a9d8edb5847dec580d6dedce539f840b.svg";
export { ForwardRef as ReactComponent };